import Api from 'services/api';

export const initializeBlockForStep = (step_id, block) => {
  return new Promise((resolve, reject) => {
    Api.get('/blocks/new', {
      params: {
        step_id,
        block,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};

export const initializeBlockForMulti = (multi_id, block) => {
  return new Promise((resolve, reject) => {
    Api.get('/blocks/new', {
      params: {
        multi_id,
        block,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};

export const createBlockForStep = (step_id, block) => {
  return new Promise((resolve, reject) => {
    Api.post('/blocks', {
      step_id,
      block,
    })
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};

export const createBlockForMulti = (multi_id, block) => {
  return new Promise((resolve, reject) => {
    Api.post('/blocks', {
      multi_id,
      block,
    })
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};

export const createBlock = (
  id,
  forMulti = false,
  kind,
  options = {},
  step_id,
) => {
  let data = {
    step_id,
    block: {
      kind,
      ...options,
    },
  };
  if (forMulti) {
    data.multi_id = id;
  } else {
    data.step_id = id;
  }
  return new Promise((resolve, reject) => {
    Api.post('/blocks', data)
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};

export const updateBlock = (block_id, data) => {
  return new Promise((resolve, reject) => {
    Api.put(`/blocks/${block_id}`, {
      block: data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};

export const deleteBlock = (block_id) => {
  return new Promise((resolve, reject) => {
    Api.delete(`/blocks/${block_id}`)
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};

export const getBlock = (block_id, expand = ['block.operations']) => {
  return new Promise((resolve, reject) => {
    Api.get(`/blocks/${block_id}`, { params: { expand } })
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};
